var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',{attrs:{"label":"Provider","item-text":"label","item-value":"code","items":_vm.allowedProviders,"outlined":_vm.outlined,"hide-details":_vm.hideDetails,"multiple":"","dense":_vm.dense},on:{"change":_vm.onChange},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-03be2e59","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/gt/shared/ProviderListSelect.vue
// module id = null
// module chunks = 